if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.handleScroll = this.handleScroll.bind(this);
      this.handleStickySubmit = this.handleStickySubmit.bind(this);

      this.sectionId = this.dataset.section;
      this.variantChangeUnsubscriber = undefined;
      this.stickySubmitButton = undefined;
    }

    connectedCallback() {
      this.targetElement = document.querySelector(
        'product-form:not(.sticky-atc) button[id^="ProductSubmitButton-"]'
      );

      this.footerElement = document.querySelector('footer');

      this.stickyAtcVariantInput = this.querySelector(
        '.product-variant-id'
      );

      this.stickySubmitButton = this.querySelector(
        '[data-sticky-submit]'
      );

      if (this.stickySubmitButton) {
        this.stickySubmitButton.addEventListener(
          'click',
          this.handleStickySubmit
        );
      }

      window.addEventListener('scroll', this.handleScroll, {
        passive: true
      });

      document.addEventListener('scroll', this.handleScroll, {
        passive: true,
        capture: true
      });

      window.addEventListener('resize', this.handleScroll);

      if (window.visualViewport) {
        window.visualViewport.addEventListener(
          'resize',
          this.handleScroll
        );
      }

      this.variantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.handleVariantChange.bind(this)
      );

      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);

      document.removeEventListener(
        'scroll',
        this.handleScroll,
        true
      );

      window.removeEventListener('resize', this.handleScroll);

      if (window.visualViewport) {
        window.visualViewport.removeEventListener(
          'resize',
          this.handleScroll
        );
      }


      if (this.stickySubmitButton) {
        this.stickySubmitButton.removeEventListener(
          'click',
          this.handleStickySubmit
        );
      }

      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    handleStickySubmit(event) {
      event.preventDefault();

      const mainSubmitButton = document.querySelector(
        'product-form:not(.sticky-atc) button[id^="ProductSubmitButton-"]'
      );

      if (!mainSubmitButton) return;

      if (mainSubmitButton.disabled) return;

      mainSubmitButton.click();
    }

    getAbsoluteTop(element) {
      if (!element) return 0;

      let top = 0;

      while (element) {
        top += element.offsetTop || 0;
        element = element.offsetParent;
      }

      return top;
    }

    handleScroll() {
      const targetElement = document.querySelector(
        'product-form:not(.sticky-atc) button[id^="ProductSubmitButton-"]'
      );

      const footerElement = document.querySelector('footer');

      if (!targetElement || !footerElement) {
        this.classList.remove('show');
        return;
      }

      this.targetElement = targetElement;
      this.footerElement = footerElement;

      const targetRect =
        targetElement.getBoundingClientRect();

      const footerRect =
        footerElement.getBoundingClientRect();

      // 主产品 Add to Cart 顶部滚出屏幕后显示
      const isTargetElementOutOfView =
        targetRect.top <= 0;

      // Footer 未进入屏幕前保持显示
      const isFooterOutOfView =
        footerRect.top > window.innerHeight;

      this.classList.toggle(
        'show',
        isTargetElementOutOfView &&
          isFooterOutOfView
      );
    }


    handleVariantChange({ data: { sectionId, html, variant } }) {
      const mainSectionId = this.sectionId.replace(
        /^template--\d+__/,
        ''
      );

      const eventSectionId = sectionId.replace(
        /^template--\d+__/,
        ''
      );

      if (mainSectionId !== eventSectionId) return;

      if (this.stickyAtcVariantInput) {
        this.stickyAtcVariantInput.value = variant?.id || '';

        this.stickyAtcVariantInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

      this.updateStickyOptionsFromHTML(
        sectionId,
        html
      );
    }

    updateStickyOptionsFromHTML(sectionId, html) {
      const sourceOptionsContainer = html.querySelector(
        '.selected-variant-details .options-container'
      );

      const destinationOptionsContainer = this.querySelector(
        '.selected-variant-details .options-container'
      );

      if (
        !sourceOptionsContainer ||
        !destinationOptionsContainer
      ) {
        return;
      }

      const sourceOptions =
        sourceOptionsContainer.querySelectorAll(
          '.selected-variant-option'
        );

      const destinationOptions =
        destinationOptionsContainer.querySelectorAll(
          '.selected-variant-option'
        );

      sourceOptions.forEach((sourceOption, index) => {
        if (destinationOptions[index]) {
          destinationOptions[index].textContent =
            sourceOption.textContent;
        }
      });
    }
  }

  customElements.define(
    'product-add-to-cart-sticky',
    ProductAddToCartSticky
  );
}
